// pages/404.js
export default function Custom404() {
  return <h1>This video is not available anymore</h1>;
}
